<template>
    <div class="col" v-if="vacationdata" name="myvacationyear">
        <div class="row mb-1">
            <div class="col">
                <h4 class="d-inline">{{ $trans.get("__JSON__.Vacation") }} {{ year }}</h4><span v-if="vacationdata.afterContractDays > 0" class="float-end font-weight-bolder">* {{ $trans.get('__JSON__.On contract renewal') }}</span>
            </div>
        </div>
        <div class="row mb-1">
            <div class="col-9">
                {{ $trans.get("__JSON__.Vacation entitlement") }}
            </div>
            <div class="col-3 text-end">
                {{ vacationdata.yearlyDays }}<span class="blue font-weight-bold" v-if="vacationdata.afterContractDays > 0"> + {{ vacationdata.afterContractDays }}</span>
            </div>
        </div>
        <div class="row mb-1">
            <div class="col-9">
                {{ $trans.get("__JSON__.Carryover last year") }}
            </div>
            <div class="col-3 text-end">
                {{ vacationdata.yearlyCarryover }}
            </div>
        </div>
        <div class="row mb-1 fw-bold">
            <div class="col-9 border-top">
                {{ $trans.get("__JSON__.Sum") }}
            </div>
            <div class="col-3 border-top text-end">
                {{ vacationdata.yearlyDays + vacationdata.afterContractDays + vacationdata.yearlyCarryover }}
            </div>
        </div>

        <div class="row mt-2 mb-1" v-if="!vacationdata.external">
            <div class="col-9">
                {{ $trans.get("__JSON__.Used vacation days") }}
            </div>
            <div class="col-3 text-end">
                {{ vacationdata.daysUsed * -1 }}
            </div>
        </div>
        <div class="row mb-1">
            <div class="col-9">
                {{ $trans.get("__JSON__.Vacation granted") }}
            </div>
            <div class="col-3 text-end">
                {{ vacationdata.daysGranted }}
            </div>
        </div>
        <div class="row mb-1">
            <div class="col-9">
                {{ $trans.get("__JSON__.Requested vacations") }}
            </div>
            <div class="col-3 text-end">
                {{ vacationdata.daysRequested }}
            </div>
        </div>
        <div class="row mb-1 fw-bold" v-if="!vacationdata.external">
            <div class="col-9 border-top">
                {{ $trans.get("__JSON__.Sum") }}
            </div>
            <div class="col-3 border-top text-end">
                {{ vacationdata.daysRequested + vacationdata.daysGranted + vacationdata.daysUsed * -1 }}
            </div>
        </div>

        <div class="row mt-2 mb-1" v-if="!vacationdata.external && vacationdata.yearlyCarriedOver == 0">
            <div class="col-9">
                {{ $trans.get("__JSON__.Days available") }}
            </div>
            <div class="col-3 text-end"> 
                {{ vacationdata.daysLeft + vacationdata.afterContractDays }}
            </div>
        </div>
        <div class="row mt-2 mb-1" v-if="!vacationdata.external && vacationdata.yearlyCarriedOver != 0">
            <div class="col-9">
                {{ $trans.get("__JSON__.Days transfered") }}
            </div>
            <div class="col-3 text-end">
                {{ vacationdata.yearlyCarriedOver * -1 }}
            </div>
        </div>
    </div>

</template>

<script>
import { getTransitionRawChildren, ref, watch } from "vue";
import {luxonParseDate} from "../transformDate"; 

export default {
    name: "MyVacationYear",
    props: {
        employee_id: String,
        year: String
    },
    data() {
        return {
            employee: null,
            vacationdata: null,
        }
    },
    created() {
        this.getEmployee();
        this.getVacationData();
    },
    mounted() {
    },
    methods: {
        getEmployee() {
            axios
                .get("/api/employees/" + this.employee_id)
                .then((resp) => {
                    this.employee = resp.data;
                })
                .catch((error) => {
                    console.log(error.response.data.errors);
                    this.errors = error.response.data.errors;
                });

        },
        getVacationData() {
            axios
                .get("/api/employees/" + this.employee_id + '/vacationdata', {
                    params: {
                        year: this.year
                    }
                })
                .then((resp) => {
                    this.vacationdata = resp.data;
                })
                .catch((error) => {
                    console.log(error.response.data.errors);
                    this.errors = error.response.data.errors;
                });

        },
        transformDate(date) {
            return luxonParseDate(date);
        }
    }
}
</script>

<style lang="scss"></style>
